enum PublishTaskStep {
    PUBLISH_METHOD_SELECT = 'publish_method_select',
    MANUAL = 'manual',
    PAYMENT = 'payment',
    QUOTA = 'quota',
    CREDIT = 'credit',
}

export default PublishTaskStep;
